import { Injectable } from '@angular/core';
import { SettingsService } from 'services/settings.service';
import { DateTime } from 'luxon';
import { DebugState } from '@cf-shared/data-model/user-state';
import { UserDb } from 'services/user-db.service';
import { DatabaseWrapper } from 'services/database-wrapper';
import { resolveFakeNow } from './debug-now';

@Injectable()
export class DebugService {
  private pageDebugData: any;
  private debugState: DebugState;
  private userDb: UserDb;

  constructor(private settings: SettingsService) { }

  async initializeAsync(userDb: UserDb) {
    this.userDb = userDb;
    return this.loadDebugStateAsync();
  }

  async loadDebugStateAsync() {
    this.debugState = await this.userDb.database.withDocWatcherAsync(watcher => this.userDb.loadDebugStateAsync(watcher));
  }
  async saveDebugStateAsync() {
    await this.userDb.saveDebugStateAsync(DatabaseWrapper.getTransactionId());
  }

  /** Be careful to call with null before exiting the page! */
  setPageDebug(pageDebugData: any) {
    // don't store references to objects unless in debug mode (would extend their lifetimes in release in case of debug mode bugs)
    if (!this.settings.testMode) {
      this.pageDebugData = null;
      return;
    }

    this.pageDebugData = pageDebugData;
  }
  getPageDebug(): any {
    return this.pageDebugData;
  }

  async setNowLocalAsync(now: DateTime | null) {
    if (now === null) {
      this.debugState.fakeNow = null;
    } else {
      this.debugState.fakeNow = now.toISO();
    }
    await this.saveDebugStateAsync();
  }
  // returns "now" honoring the debug fakeNow override, with the DST-aware device zone preserved (see resolveFakeNow)
  getNowLocal(): DateTime {
    return resolveFakeNow(this.debugState?.fakeNow, DateTime.local());
  }

  // Check whether the given UTC time is before the current time
  isBeforeNow_utc(utcTime: string) {
    const now = this.getNowLocal().toUTC();
    const time = DateTime.fromISO(utcTime);
    return time <= now;
  };

  async setNowLocalDayAsync(now: DateTime) {
    let realNow = DateTime.local();
    let newNow = now.set({
      hour: realNow.hour,
      minute: realNow.minute,
      second: realNow.second,
      millisecond: realNow.millisecond
    });
    await this.setNowLocalAsync(newNow);
  }
}
